import script from "./PlanUpgrade.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanUpgrade.vue?vue&type=script&setup=true&lang=js"

import "./PlanUpgrade.vue?vue&type=style&index=0&id=0a616d22&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a616d22"]])

export default __exports__